import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../../../../../admin/src/app/services/user.service';

@Component({
  selector: 'app-campaign-update-modal',
  templateUrl: './campaign-update-modal.component.html',
  styleUrl: './campaign-update-modal.component.scss',
})
export class CampaignUpdateModalComponent implements OnInit, OnDestroy {
  constructor(public userService: UserService) {}

  ngOnInit(): void { }

  ngOnDestroy(): void {
    //* Clean up work
    // this.userService.clearUserForm();
  }
}
